import { NextPage } from "next";
import { useState } from "react";
import { LandingPageHero } from "~/components/LandingPageV2/components/LandingPageHero";
import { LandingPagePostEditCTA } from "~/components/LandingPageV2/components/LandingPagePostEditCTA";
import { PostEditCTAProps } from "~/components/PostEditCTA";
import { LandingPageBlocks } from "./LandingPageBlocks";
import { LandingPageBlockV2, LandingPageV2Hero } from "./schemas";

export interface LandingPageV2Props {
  blocks: LandingPageBlockV2[];
  heroProps: LandingPageV2Hero;
  postId: number;
  postName: string;
  preview: boolean;
  postEditCTAProps: PostEditCTAProps;
}

export const LandingPageV2: NextPage<LandingPageV2Props> = ({
  blocks,
  heroProps,
  postId,
  postName,
  preview,
  postEditCTAProps,
}): JSX.Element => {
  const [highlightBlocks, setHighlightBlock] = useState(false);
  return (
    <>
      <LandingPagePostEditCTA
        {...postEditCTAProps}
        isChecked={highlightBlocks}
        setIsChecked={setHighlightBlock}
      />
      <div>
        <LandingPageHero {...heroProps} highlightBlock={highlightBlocks} />
        <LandingPageBlocks
          blocks={blocks}
          preview={preview}
          postId={postId}
          postName={postName}
          showBlockOverlay={highlightBlocks}
        />
      </div>
    </>
  );
};
